module.exports = __webpack_public_path__ + "static/media/n11.a74caebe.jpg";